module.exports = __webpack_public_path__ + "img/PrintButton.1e12a5f9.svg";